import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Typography } from '@klarna/bubble-ui';

const borderColor = '#c7c9cc';

const Container = styled.div`
  position: relative;
  background: #fff;
  border: 1px solid ${borderColor};
  min-height: 20px;
  padding: 5px 10px;
  display: flex;
  justify-content: center;
  align-items: center;

  ::after,
  ::before {
    top: 100%;
    left: 50%;
    border: solid transparent;
    content: '';
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }

  ::after {
    border-color: rgba(255, 255, 255, 0);
    border-top-color: #fff;
    border-width: 10px;
    margin-left: -10px;
  }

  ::before {
    border-color: rgba(0, 0, 0, 0);
    border-top-color: ${borderColor};
    border-width: 11px;
    margin-left: -11px;
  }
`;

export const TextBoxWithArrow = ({ text = '' }) => {
  return (
    <Container>
      <Typography textToken="text-style/text/super-paragraphs/body/regular" align="center">
        {text}
      </Typography>
    </Container>
  );
};

TextBoxWithArrow.propTypes = {
  text: PropTypes.string.isRequired,
};
